<template>
    <div class="text">
        <textarea placeholder="按 Ctrl + Enter 发送" class="inputword"></textarea>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    .text
        border-top: 1px solid grey 
        .inputword
            padding: 10px;
            height: 100%;
            width: 100%;
            border: none;
            outline: none;
            font-family: "Micrsofot Yahei";
            resize: none;
</style>



// WEBPACK FOOTER //
// src/components/inline-text/inline-text.vue